import Vue from 'vue'
import Router from 'vue-router'
// import Index from '@/pages/index/Index'
import Index from '@/components/Index'
import CoreProduct from '@/components/CoreProduct'
import Cooperation from '@/components/Cooperation'
import AboutUs from '@/components/AboutUs'

import RingoneRecord from '@/components/RingoneRecord'
import Ringone from '@/components/Ringone'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/index',
      name: 'Index',
      component: Index
    },{
      path: '/coreProduct',
      name: '核心产品',
      component: CoreProduct
    },{
      path: '/ringone',
      name: '企业彩铃',
      component: Ringone
    },{
      path: '/ringoneRecord',
      name: '铃音录制',
      component: RingoneRecord
    },{
      path: '/cooperation',
      name: '市场合作',
      component: Cooperation
    },{
      path: '/aboutUs',
      name: '关于我们',
      component: AboutUs
    },{
      path: '/',
      redirect: '/index'
    },{
      path: '/page1',
      redirect: '/index'
    },{
      path: '/page2',
      redirect: '/index'
    },{
      path: '/page3',
      redirect: '/index'
    },{
      path: '/page4',
      redirect: '/index'
    },{
      path: '/page5',
      redirect: '/index'
    },{
      path: '/page6',
      redirect: '/index'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js